import { Question } from '../types/question';
import { OpenAIService } from './openaiService';

export class AnswerEvaluator {
  private openAIService: OpenAIService;

  constructor() {
    this.openAIService = new OpenAIService();
  }

  async evaluateAnswer(question: Question, answer: string): Promise<{
    score: number;
    feedback: string;
  }> {
    try {
      // Use OpenAI to evaluate the answer
      const evaluation = await this.openAIService.evaluateAnswer(question, answer);

      // Normalize score to be between 0 and 1
      const normalizedScore = Math.max(0, Math.min(1, evaluation.score));

      return {
        score: normalizedScore,
        feedback: evaluation.feedback
      };
    } catch (error) {
      console.error('Error evaluating answer:', error);
      throw error;
    }
  }
}

export interface EvaluationResult {
  correct: boolean;
  feedback: string;
  score?: number;
}

export interface EvaluationConfig {
  type: string;
  criteria: any;
}

export const evaluateAnswer = (
  questionId: string,
  answer: string,
  config: EvaluationConfig
): EvaluationResult => {
  // Basic implementation - you can enhance this based on your needs
  return {
    correct: true,
    feedback: 'Answer evaluated successfully',
    score: 1.0
  };
};

export const getHeartLessonEvaluationConfig = (questionId: string): EvaluationConfig | null => {
  // Return appropriate config for heart lesson questions
  return {
    type: 'exact',
    criteria: {
      tolerance: 0.8
    }
  };
}; 